<template>
    <div>
        <back-btn />
      <bread-cump :cumps="$route.meta.breadcrumps" />
      <v-container fluid>
        <v-row class="ml-3">
          <h4>Month : {{ $route.params.month }}</h4>
          <h4 class="ml-3">Year : {{ $route.params.year }}</h4>
        </v-row>
        <v-row justify="center">
          <v-col lg="12">
            <v-card class="card--shadow">
              <list :ciData="ciData" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import List from "@/components/ci/List";
  import { mapState } from "vuex";
  import BreadCump from "@/components/navigation/BreadCump";
  import BackBtn from "@/components/navigation/BackBtn.vue";
  
  export default {
    components: {
      List,
      BreadCump,BackBtn
    },
    computed: {
      ...mapState("Ci", ["ciData"]),
    },
  
    created() {
      const param = {
        month: this.$route.params.month,
        year: this.$route.params.year,
        township_id: this.$route.params.township_id,
      };
      this.$store.dispatch("Ci/getAll", param);
      
    },
  };
  </script>
  